import xhr from 'xhr';

export default async function getStudentGuides(data) {
  const res = await xhr(`/student-guide-numbers?filters[student][id][$eq]=${data.id}&sort[0]=createdAt:DESC`);

  return res.data.data;
}
